import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import Box from '@material-ui/core/Box';
import { makeCoverStyles } from 'styles/pages/product';
import { utils } from 'styles';
import { SIZES } from '../common/constants';
import classNames from 'classnames';

type Props = {
    thumbnail: Array<{
        path: string;
        sizes: Array<{
            absolutePath: string;
            size: string;
        }>;
    }>;
    type?: string;
};

const ProductCover: React.FC<Props> = ({ thumbnail, type }) => {
    const [isOpen, setOpen] = useState(false);

    const { cover } = makeCoverStyles();
    const [{ absolutePath }] = thumbnail[0]?.sizes?.filter(({ size }) => size === SIZES.LARGE) || [{ absolutePath: null }];

    const [{ absolutePath: absolutePathOriginal }] = thumbnail[0]?.sizes?.filter(
        ({ size }) => size === SIZES.ORIGINAL,
    ) || [{ absolutePath: null }];

    const isBook = type == 'BOOK';
    const borderStyles = { border: '1px solid #d1d6d6' };
    const borderColor = utils.makeGenericStyles(borderStyles);

    const handleClick = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Box alignItems="center" display="flex" justifyContent="center">
            { absolutePath && (
                <img alt="cover" className={classNames('cover', { [borderColor.root]: isBook })} onClick={handleClick} src={absolutePath} />
            )}
            {isOpen && (
                <Lightbox
                    enableZoom={false}
                    mainSrc={absolutePathOriginal}
                    onCloseRequest={handleClose}
                />
            )}
        </Box>
    );
};

export default ProductCover;
